<template>
  <list :list="list"
        :infiniteId="loadingId"
        :headers="headers"
        :loading="loading"
        @load="fetchList"
        @reload="reloadList">
    <template slot="default"
              slot-scope="slotProps">
      <login-personalize-list-item :item="slotProps.item"
                                   @deleted="reloadList" />
    </template>
  </list>
</template>

<script>
import LoginPersonalizeListItem from "@components/modules/login-personalize/list/item/LoginPersonalizeListItem";
import List from "@/components/generic/list/List";

export default {
  components: {
    List,
    LoginPersonalizeListItem,
  },

  data() {
    return {
      list: [],
      internalInfiniteId: +new Date(),
      headers: [
        {
          text: this.$t("message.generics.message.name"),
          value: "",
          sortable: false,
        },
        {
          text: this.$t("message.generics.message.creationDate"),
          value: "onceTimePerDay",
          sortable: false,
        },
      ],
      loading: false,
    };
  },

  props: {
    infiniteId: {
      type: Number,
    },
  },

  computed: {
    loadingId() {
      return this.infiniteId || this.internalInfiniteId;
    },
  },

  methods: {
    async reloadList() {
      this.internalInfiniteId++;
    },
    async fetchList($state) {
      this.loading = true;

      const list = await this.$api.core.account.captiveStyle.list();

      this.list = list;

      $state.complete();

      this.loading = false;
    },
    emitSelected(domain) {
      this.$emit("selected", domain);
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.login-forms-header {
  display: flex;
  align-items: center;
}
</style>
